export const FeaturedProjectPlaceholder = () => {
  return (
    <div className="duraton-200 h-[560px] w-full animate-pulse bg-core-gray-950 ease-in-out sm:h-[640px] lg:h-[720px] 2xl:h-[900px] 3xl:h-[1200px]" />
  )
}
